import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { TestUiComponentsPage } from 'pages/test-ui-components/test-ui-components';
import { CsTestAlertsCardComponent } from 'pages/test-ui-components/cs-test-alerts-card';
import { CsTestCalendarCardComponent } from 'pages/test-ui-components/cs-test-calendar-card';
import { CsTestChartsCardComponent } from 'pages/test-ui-components/cs-test-charts-card';
import { CsTestCheckboxCardComponent } from 'pages/test-ui-components/cs-test-checkbox-card';
import { CsTestColorsCardComponent } from 'pages/test-ui-components/cs-test-colors-card';
import { CsTestContentCardComponent } from 'pages/test-ui-components/cs-test-content-card';
import { CsTestControlOutlinesCardComponent } from 'pages/test-ui-components/cs-test-control-outlines-card';
import { CsTestDoubleClickCardComponent } from 'pages/test-ui-components/cs-test-double-click-card';
import { CsTestHeadersCardComponent } from 'pages/test-ui-components/cs-test-headers-card';
import { CsTestHintBubbleCardComponent } from 'pages/test-ui-components/cs-test-hint-bubble-card';
import { CsTestInputMeasureCardComponent } from 'pages/test-ui-components/cs-test-input-measure-card';
import { CsTestLayoutCardComponent } from 'pages/test-ui-components/cs-test-layout-card';
import { CsTestLoadingCardComponent } from 'pages/test-ui-components/cs-test-loading-card';
import { CsTestLoadingTextsCardComponent } from 'pages/test-ui-components/cs-test-loading-texts-card';
import { CsTestMenusCardComponent } from 'pages/test-ui-components/cs-test-menus-card';
import { CsTestNavigationCardComponent } from 'pages/test-ui-components/cs-test-navigation-card';
import { CsTestPermissionDeniedDemoComponent } from 'pages/test-ui-components/cs-test-permission-denied-demo';
import { CsTestPickersCardComponent } from 'pages/test-ui-components/cs-test-pickers-card';
import { CsTestRadioCardComponent } from 'pages/test-ui-components/cs-test-radio-card';
import { CsTestRestTimerCardComponent } from 'pages/test-ui-components/cs-test-rest-timer-card';
import { CsTestRestTimerDemoComponent } from 'pages/test-ui-components/cs-test-rest-timer-demo';
import { CsTestScannerPartsCardComponent } from 'pages/test-ui-components/cs-test-scanner-parts-card';
import { CsTestStatusFeedbackCardComponent } from 'pages/test-ui-components/cs-test-status-feedback-card';
import { CsTestTableCardComponent } from 'pages/test-ui-components/cs-test-table-card';
import { CsTestTabsCardComponent } from 'pages/test-ui-components/cs-test-tabs-card';
import { CsTestToggleCardComponent } from 'pages/test-ui-components/cs-test-toggle-card';
import { CsTestTooltipCardComponent } from 'pages/test-ui-components/cs-test-tooltip-card';

@NgModule({
    declarations: [
        TestUiComponentsPage,
        CsTestAlertsCardComponent,
        CsTestCalendarCardComponent,
        CsTestChartsCardComponent,
        CsTestCheckboxCardComponent,
        CsTestColorsCardComponent,
        CsTestContentCardComponent,
        CsTestControlOutlinesCardComponent,
        CsTestDoubleClickCardComponent,
        CsTestHeadersCardComponent,
        CsTestHintBubbleCardComponent,
        CsTestInputMeasureCardComponent,
        CsTestLayoutCardComponent,
        CsTestLoadingCardComponent,
        CsTestLoadingTextsCardComponent,
        CsTestMenusCardComponent,
        CsTestNavigationCardComponent,
        CsTestPermissionDeniedDemoComponent,
        CsTestPickersCardComponent,
        CsTestRadioCardComponent,
        CsTestRestTimerCardComponent,
        CsTestRestTimerDemoComponent,
        CsTestScannerPartsCardComponent,
        CsTestStatusFeedbackCardComponent,
        CsTestTableCardComponent,
        CsTestTabsCardComponent,
        CsTestToggleCardComponent,
        CsTestTooltipCardComponent,
    ],
    imports: [PagesModule, ComponentsModule],
    exports: [TestUiComponentsPage]
})
export class TestUiComponentsPageModule { }
